import * as React from "react";
import type { SVGProps } from "react";
const CleaningServices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7227)">
      <path
        fill="currentColor"
        d="M22.7643 4.0973c.4801-.4802.4801-1.26 0-1.7401-.4802-.4802-1.2599-.4802-1.7401 0l-7.3751 7.3751-1.3329-1.3329a.872.872 0 0 0-.6146-.2535.867.867 0 0 0-.8681.8681v1.1178l4.16 4.16h1.1178a.867.867 0 0 0 .8681-.8681.872.872 0 0 0-.2535-.6146l-1.3329-1.3329 7.3751-7.3751zm-8.6619 11.4775L9.5505 11.023c-1.6402-.1422-3.2727.4494-4.448 1.6248l-.3074.3073a4.562 4.562 0 0 0-1.3367 3.2266c0 .2612.2727.4302.507.315l1.9629-.9795c.192-.0961.3649.1575.2074.3034l-4.8553 4.3636A.86.86 0 0 0 1 20.818c0 .4687.3803.8489.849.8489h6.6567c1.4904 0 2.9155-.5915 3.9718-1.644 1.1754-1.1754 1.7631-2.8079 1.6249-4.4481"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_7227">
        <path fill="transparent" d="M1 2h22.1254v19.667H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default CleaningServices;
